/* unplugin-vue-components disabled */import script from "./project-item.vue?vue&type=script&setup=true&lang=js"
export * from "./project-item.vue?vue&type=script&setup=true&lang=js"

import "./project-item.vue?vue&type=style&index=0&id=bcb0415e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb0415e"]])

export default __exports__